// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'user-question-mark-solid';

export const Component = () => (
  <path d='M23.61 5.85c0-1.1-.4-2-1.1-2.7-.8-.8-1.7-1.1-2.7-1.1-1.1 0-2 .4-2.7 1.1-.8.8-1.1 1.7-1.1 2.7 0 .4.2.5.6.5.4 0 .5-.2.5-.5 0-.8.3-1.4.8-2 .5-.5 1.2-.8 1.9-.8.8 0 1.4.3 1.9.8s.8 1.2.8 2v.6c0 .8-.4 1.3-1.1 1.6 0 0-.7.3-1 .4-.8.3-1.1.7-1.1 1.6v1.4c0 .7 1 .6 1 0v-1.5c0-.3.1-.5.4-.6.3 0 1.1-.2 1.1-.2 1.1-.4 1.8-1.3 1.8-2.6zm-4.4 8.2h1.1v-1.1h-1.1zM3.968 6.886c0-1.34.479-2.49 1.436-3.448C6.363 2.479 7.512 2 8.854 2c1.389 0 2.538.479 3.496 1.437.958.958 1.437 2.107 1.437 3.448 0 1.39-.48 2.538-1.437 3.496-.958.958-2.107 1.437-3.496 1.437-1.34 0-2.49-.479-3.449-1.437-.957-.958-1.436-2.107-1.436-3.496Zm4.885 5.89c2.155 0 4.023.767 5.555 2.3 1.533 1.533 2.3 3.4 2.3 5.555v.48c0 .335-.144.526-.48.526h-14.7c-.336 0-.527-.191-.527-.527v-.479c0-2.155.766-3.975 2.3-5.507 1.58-1.58 3.4-2.347 5.555-2.347z' />
);

export const viewBox = '0 0 25 25';
